var map = {
	"./address_image.svg": 157,
	"./animated_logo.svg": 158,
	"./blogs_image.svg": 159,
	"./brossard_logo.ico": 160,
	"./clickatell_logo.svg": 161,
	"./cloud_infrastructure.svg": 162,
	"./codeInLogo.png": 163,
	"./contactMail.png": 164,
	"./coursera_logo.png": 165,
	"./data_science.svg": 166,
	"./deeplearning_ai_logo.png": 167,
	"./delhivery_logo.png": 168,
	"./developerActivity.svg": 169,
	"./digitalOcean_logo.png": 170,
	"./dsc_logo.png": 171,
	"./education.svg": 172,
	"./experience.svg": 173,
	"./feelingProud.svg": 174,
	"./freecopy_logo.png": 175,
	"./fullstack.svg": 176,
	"./gcp_logo.png": 177,
	"./github_logo.png": 178,
	"./googleAssistant.jpg": 179,
	"./googleAssistant.svg": 180,
	"./googleAssistantLogo.webp": 181,
	"./google_logo.png": 182,
	"./herzing_logo.png": 183,
	"./ibm_logo.png": 184,
	"./iiitk_logo.png": 185,
	"./intel_logo.jpg": 186,
	"./jsFramework.svg": 187,
	"./legato_logo.png": 188,
	"./manOnTable.svg": 189,
	"./microsoft_azure.png": 190,
	"./microsoft_azure1.png": 191,
	"./microsoft_logo.png": 192,
	"./microsoft_logo1.png": 193,
	"./mozilla_logo.png": 194,
	"./muffito_logo.png": 195,
	"./nextuLogo.jpg": 196,
	"./nptel_logo.png": 197,
	"./nso.jpg": 198,
	"./portfolio.gif": 199,
	"./programmer.svg": 200,
	"./projects_image.svg": 201,
	"./pwa.png": 202,
	"./saayaHealthLogo.png": 203,
	"./sof.jpg": 204,
	"./stanford_logo.png": 205,
	"./talksCardBack.svg": 206,
	"./talksCardBackAlt.svg": 207,
	"./tapan.jpg": 208,
	"./tapan_animated.gif": 209,
	"./tapan_logo.png": 210,
	"./tapan_logo_circled.png": 211,
	"./tapan_new_logo.jpg": 212,
	"./tapan_profile.png": 213,
	"./timeb_logo.svg": 214,
	"./ui_ux_design.svg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;